<ul class="navbar-side-links">
  <li class="d-flex align-items-center ps-4 pe-4 navbar-nav__nav-item">
    <digital-platform-rsx-a
      url="/search"
      klass="text-color-white text-decoration-none"
      class="navbar-nav__rich-text-link"
    >
      <digital-platform-icon
        icon="navigation-search"
        color="white"
      ></digital-platform-icon>
    </digital-platform-rsx-a>
  </li>
</ul>
